// Copy for the homepage (src/pages/Index.tsx + src/components/home/*) that is not in translations/home.ts.

const en = {
  seo: {
    title: 'Stratodata | Trusted Data Foundation for Decisions & AI',
    description:
      'Every system shows a different number? We build your data foundation: one source of truth for profit, trusted reporting, and AI when you’re ready.',
  },
  hero: {
    // Small line under the booking button; empty = not shown
    ctaNote: '',
    slide1: { line1: 'Numbers You Can', accent: 'Build On' },
    slide2: {
      kicker: 'Retail Automation Suite (RAS)',
      line1: 'Know Exactly',
      accent: 'What To Do Next',
      subtitle: 'Which products to push, which to keep, and which to cut,\nbased on what they really earn.',
      cta: 'Explore RAS',
    },
    slide3: {
      kicker: 'Digital CFO',
      before: 'See Your ',
      accent: 'Real Profit',
      line2: 'Per Product',
      subtitle: 'Margin after ads, returns and discounts, updated daily instead of at month-end.\nA number you can defend in front of the board.',
      cta: 'Explore Digital CFO',
    },
    slide4: {
      kicker: 'Data Warehousing & Consulting',
      line1: 'We Lay The Groundwork.',
      accent: 'And Grow With Your Team.',
      subtitle: 'We connect and clean your sales, marketing, finance and warehouse numbers,\nthen keep training your team as your questions get bigger.',
      cta: 'Explore Data Warehousing',
    },
    slide5: {
      kicker: 'Talk to your data',
      line1: 'Ask Your Data.',
      accent: 'Trust The Answer.',
      subtitle: 'Ask a question in plain language and get an answer in a minute,\nbuilt on numbers we keep clean and connected.',
      cta: 'Explore Context Engineering',
    },
    prevSlide: 'Previous slide',
    nextSlide: 'Next slide',
    goToSlide: 'Go to slide',
  },
  logos: {
    clientLogo: 'Client logo',
  },
  audience: {
    badge: 'Two ways to start',
    title: 'Start where it hurts most.',
    text: 'Same platform underneath — pick the door that matches how you already think about the problem.',
    profit: {
      label: 'For the P&L',
      title: 'See your real profit, per channel and SKU',
      body: 'A validated margin and EBIT number you can defend in a board meeting — updated daily, not at month-end.',
      cta: 'Explore Digital CFO',
    },
    data: {
      label: 'For the data stack',
      title: 'Build a data foundation your team can trust',
      body: 'Connect ERP, e-shop and marketing data into one verified model — no rip-and-replace, no more disagreeing dashboards.',
      cta: 'Explore Data Warehousing',
    },
  },
  solutions: {
    exploreMore: 'Explore more',
    // Extra first bullet on the "Talk to your data" card; empty = not shown
    aiDataFeature: '',
  },
  consulting: {
    tellMeMore: 'Tell me more',
  },
  values: {
    badge: 'How we work',
    title: 'No more guessing. Just clarity you can act on — every day.',
    items: [
      {
        title: 'Ownership',
        text: "We don't just hand you a dashboard — we build the data model with your team, then keep it running.",
      },
      {
        title: 'Speed',
        text: "Daily numbers, not month-end reports. If it doesn't help you decide today, it's not worth building.",
      },
      {
        title: 'Proof',
        text: "Every number reconciles back to your books. If the channels don't tie out, the model is wrong.",
      },
    ],
  },
  reminder: {
    question: 'Still deciding where to start?',
    profit: 'For the P&L',
    profitSub: 'Digital CFO',
    data: 'For the data stack',
    dataSub: 'Data Warehousing',
  },
};

const sk: typeof en = {
  seo: {
    title: 'Stratodata | Spoľahlivý dátový základ pre rozhodnutia a AI',
    description:
      'Každý systém ukazuje iné číslo? Postavíme vám dátový základ: jeden zdroj pravdy o zisku, reporting, ktorému sa dá veriť, a AI, keď budete pripravení.',
  },
  hero: {
    ctaNote: '',
    slide1: { line1: 'Čísla, na ktorých', accent: 'môžete stavať' },
    slide2: {
      kicker: 'Retail Automation Suite (RAS)',
      line1: 'Presne viete,',
      accent: 'čo robiť ďalej',
      subtitle: 'Ktoré produkty podporiť, ktoré si nechať a ktoré vyradiť,\npodľa toho, koľko naozaj zarábajú.',
      cta: 'Zistiť viac o RAS',
    },
    slide3: {
      kicker: 'Digital CFO',
      before: 'Vidíte ',
      accent: 'skutočný zisk',
      line2: 'na každom produkte',
      subtitle: 'Marža po odpočítaní reklamy, vratiek a zliav. Každý deň, nie až na konci mesiaca.\nČíslo, ktoré obhájite aj pred predstavenstvom.',
      cta: 'Zistiť viac o Digital CFO',
    },
    slide4: {
      kicker: 'Dátové sklady a konzultácie',
      line1: 'Položíme základy.',
      accent: 'A rastieme s vaším tímom.',
      subtitle: 'Prepojíme a vyčistíme vaše čísla z predaja, marketingu, financií a skladu.\nA keď budú otázky väčšie, váš tím budeme učiť ďalej.',
      cta: 'Zistiť viac o dátových skladoch',
    },
    slide5: {
      kicker: 'Rozprávajte sa so svojimi dátami',
      line1: 'Opýtajte sa dát.',
      accent: 'A verte odpovedi.',
      subtitle: 'Spýtajte sa bežnou rečou a odpoveď máte do minúty.\nStojí na číslach, ktoré pre vás držíme čisté a prepojené.',
      cta: 'Zistiť viac o Context Engineering',
    },
    prevSlide: 'Predchádzajúca snímka',
    nextSlide: 'Ďalšia snímka',
    goToSlide: 'Prejsť na snímku',
  },
  logos: {
    clientLogo: 'Logo klienta',
  },
  audience: {
    badge: 'Dva spôsoby, ako začať',
    title: 'Začnite tam, kde to bolí najviac.',
    text: 'Platforma je v oboch prípadoch rovnaká. Vyberte si cestu podľa toho, ako sa na problém pozeráte vy.',
    profit: {
      label: 'Pre P&L',
      title: 'Chcem vidieť skutočný zisk podľa kanálov a SKU',
      body: 'Overená marža a EBIT, ktoré obhájite pred predstavenstvom. Aktualizované každý deň, nie až na konci mesiaca.',
      cta: 'Zistiť viac o Digital CFO',
    },
    data: {
      label: 'Pre dátovú infraštruktúru',
      title: 'Chcem dátový základ, ktorému môj tím bude veriť',
      body: 'Prepojte dáta z ERP, e-shopu a marketingu do jedného overeného modelu. Systémy, ktoré máte, nemusíte meniť a dashboardy si prestanú odporovať.',
      cta: 'Zistiť viac o dátových skladoch',
    },
  },
  solutions: {
    exploreMore: 'Zistiť viac',
    aiDataFeature: 'Prepojené a vyčistené dáta z predaja, marketingu, financií a skladu ako základ pre AI',
  },
  consulting: {
    tellMeMore: 'Chcem vedieť viac',
  },
  values: {
    badge: 'Ako pracujeme',
    title: 'Žiadne hádanie. Len jasné čísla, podľa ktorých môžete konať – každý deň.',
    items: [
      {
        title: 'Zodpovednosť',
        text: 'Neodovzdáme vám len dashboard. Dátový model staviame spolu s vaším tímom a potom sa oň staráme.',
      },
      {
        title: 'Rýchlosť',
        text: 'Čísla máte každý deň, nečakáte na mesačný report. Čo vám nepomôže rozhodnúť sa ešte dnes, to nemá zmysel stavať.',
      },
      {
        title: 'Overiteľnosť',
        text: 'Každé číslo sedí s vaším účtovníctvom. Keď sa súčet za kanály nezhoduje, chyba je v modeli.',
      },
    ],
  },
  reminder: {
    question: 'Stále sa rozhodujete, kde začať?',
    profit: 'Pre P&L',
    profitSub: 'Digital CFO',
    data: 'Pre dátovú infraštruktúru',
    dataSub: 'Dátové sklady',
  },
};

export const homeCopy = { en, sk };
